import AirplanemodeActiveIcon from "@mui/icons-material/AirplanemodeActive";
import EqualizerIcon from "@mui/icons-material/Equalizer";
import LiquorIcon from "@mui/icons-material/Liquor";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import React from "react";
import { useAuth } from "../../contexts/AuthProvider.jsx";
import NavigationMenu from "../common/sidebar/NavigationMenu.jsx";
import ProfileOptionsMenu from "../common/sidebar/ProfileOptionsMenu.jsx";

const gestionLinks = [
  { to: "/", label: "Panel de Control", icon: <EqualizerIcon /> },
  { to: "/receipts", label: "Recepciones", icon: <AirplanemodeActiveIcon /> },
  { to: "/products", label: "Productos", icon: <LiquorIcon /> },
];

const Sidebar = () => {
  const { auth } = useAuth();

  return (
    <div className="col-span-1 border-gray-200 flex flex-col h-screen">
      <div className="p-4 flex-1 overflow-y-auto">
        <div className="p-6">
          <Box
            sx={{ display: "flex", alignItems: "center", gap: 1.5 }}
            className="mb-8" // Mantenemos el margen inferior
          >
            {/* 2. El 'Avatar' de MUI para tu imagen/logo */}
            <Avatar
              src="./logo.png"
              alt="Logo de TaxFlow"
              sx={{ width: 40, height: 40 }}
              variant="square"
            >
              Logo {/* Fallback si la imagen no carga */}
            </Avatar>

            {/* 3. Tu H1 (ahora sin margen inferior) */}
            <h1 className="text-4xl font-bold text-primary">
              TaxFlow
            </h1>
          </Box>
          <NavigationMenu title="Gestión" links={gestionLinks} />
        </div>
      </div>
      {auth
        ? (
          <div className="flex items-center gap-2 p-4 px-10 border-t border-border">
            <div className="mr-auto">
              <p className="font-semibold text-sm text-text-primary">
                {auth.user.name}
              </p>
              <p className="text-xs text-text-secondary">
                {auth.user.email}
              </p>
            </div>

            <ProfileOptionsMenu />
          </div>
        )
        : <div>Hola</div>}
    </div>
  );
};

export default Sidebar;
